<template>
  <ValidationProvider
    ref="validation"
    v-slot="{ errors, invalid }"
    class="mb-3"
    slim
    :rules="rules"
    :vid="vid"
  >
    <div
      v-click-outside="close"
      class="relative flex flex-col justify-center"
      @click="dropdown"
    >
      <slot name="label">
        <div v-if="label" class="mb-1 !text-left">
          <label class="block font-bold">{{ label }}</label>
        </div>
        <input v-model="value" class="hidden" />
      </slot>
      <div>
        <button
          class="inline-flex items-center justify-between gap-2 px-3 py-2 rounded border border-gray-300 bg-white text-gray-700 cursor-pointer hover:bg-gray-50"
          aria-haspopup="true"
          aria-controls="dropdown-menu"
        >
          <span>{{ shownValue }}</span>
          <span class="ml-1 flex items-center">
            <IconComponent icon="angle-down" />
          </span>
        </button>
      </div>
      <p v-show="invalid" class="text-sm text-error mt-1">
        {{ errors[0] }}
      </p>
      <div
        v-show="open"
        id="dropdown-menu"
        class="absolute top-full left-0 z-20 min-w-[12rem] pt-1"
        role="menu"
      >
        <div class="bg-white rounded shadow-md py-2">
          <a
            v-for="item in items"
            :key="item[valueKey]"
            href="#"
            class="block px-4 py-2 hover:bg-gray-100"
            @click.stop="selectItem(item)"
          >
            {{ item[labelKey] }}
          </a>
        </div>
      </div>
    </div>
  </ValidationProvider>
</template>

<script>
import IconComponent from "~/components/IconComponent.vue";

export default {
  components: { IconComponent },
  props: {
    items: {
      type: Array,
      required: true,
    },
    labelKey: {
      type: String,
      default: "label",
    },
    valueKey: {
      type: String,
      default: "value",
    },
    placeholder: {
      type: String,
      default: "Choose an item",
    },
    label: {
      type: String,
      default: "",
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    vid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      open: false,
      value: null,
    };
  },
  computed: {
    shownValue() {
      if (this.value) {
        return this.value[this.labelKey];
      }
      return this.placeholder;
    },
  },
  methods: {
    selectItem(item) {
      this.value = item;
      this.open = false;
      this.$emit("select", item);
    },
    dropdown() {
      this.open = !this.open;
    },
    close() {
      this.open = false;
    },
  },
};
</script>

<style></style>
